import timezonePickerStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_LOCAL_TIME', function setLocalTime(localTime: string) {
    timezonePickerStore.localTime = localTime;
});
